"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _TransmuteCollection = require("./TransmuteCollection");

_TransmuteCollection.reduce.implement(Array, function (into, operation, arr) {
  return arr.reduce(operation, into);
});

_TransmuteCollection.reduce.implement(Object, function (into, operation, obj) {
  var keys = Object.keys(obj);
  var len = keys.length;
  var acc = into;

  for (var i = 0; i < len; i++) {
    var key = keys[i];
    acc = operation(acc, obj[key], key, obj);
  }

  return acc;
});

_TransmuteCollection.reduce.implementInherited(_immutable.Iterable, function (into, operation, iter) {
  return iter.reduce(operation, into);
});

var _default = _TransmuteCollection.reduce;
exports.default = _default;
module.exports = exports.default;